<div class="24hr-example form-input">
  <label>{{label| translate}}  <span *ngIf="required">*</span></label>
  <mat-form-field>
    <input matInput
           [ngxTimepicker]="fullTime"
           [format]="24"
           [type]="type"
           [name]="name"
           (blur)="onTouched()"
           [required]="required"
           [value]="value"
           [(ngModel)]="value"
           [pattern]="pattern"
           [id]="name"
           [width]="'12'"
           [placeholder]="placeholder | translate" readonly>
  </mat-form-field>


  <ngx-material-timepicker #fullTime></ngx-material-timepicker>
</div>
